import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast, Toaster } from "sonner";
import api from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      sessionStorage.setItem("atelier_token", data.token);
      sessionStorage.setItem("atelier_user", JSON.stringify(data.user));
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy text-ivory flex flex-col" data-testid="admin-login-page">
      <div className="grain" />
      <Toaster theme="dark" position="bottom-right" />
      <header className="px-6 md:px-10 py-6 border-b border-ivory/10 flex justify-between">
        <Link to="/" className="font-display text-xl">The Visa <span className="italic text-gold">Atelier</span></Link>
        <span className="font-mono-ui text-[10px] tracking-[0.3em] text-gold uppercase">Admin Access</span>
      </header>
      <div className="flex-1 grid place-items-center px-6">
        <div className="w-full max-w-md border border-ivory/10 p-10">
          <div className="font-mono-ui text-[10px] tracking-[0.3em] text-gold uppercase mb-4">[ Restricted ]</div>
          <h1 className="font-display text-5xl leading-none mb-10">Sign in.</h1>
          <form onSubmit={submit} className="space-y-8" data-testid="admin-login-form">
            <div>
              <label className="block font-mono-ui text-[10px] tracking-[0.3em] uppercase text-gold mb-2">Email</label>
              <input
                type="email"
                className="field-line"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="block font-mono-ui text-[10px] tracking-[0.3em] uppercase text-gold mb-2">Password</label>
              <input
                type="password"
                className="field-line"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full py-4 bg-gold text-navy font-mono-ui text-[11px] tracking-[0.3em] uppercase hover:bg-ivory transition-colors disabled:opacity-50"
              data-testid="login-submit"
            >
              {loading ? "Authenticating…" : "Enter →"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
